import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AlertsContext from "common/providers/alerts";
import ServerForm from "./ServerForm";
import SlaveServerForm from "./SlaveServerForm";

function Server() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;
  const isMasterServer = import.meta.env.VITE_IS_MASTER_SERVER === "true";

  const { saveItem, updateItem, item, error }: any = useItem("servers", id, {});

  useEffect(() => {
    if (error) {
      console.log(error);
      setAlert(t(error), "danger");
    }
  }, [error, setAlert, t]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/servers");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataServer: any) => {
      const server = { ...dataServer };

      try {
        let result: any;
        if (server.id) {
          result = await updateItem(server.id, server);
        } else {
          result = await saveItem(server);
        }

        const licenseKey = result?.licenseKey || result?.data?.licenseKey;
        if (licenseKey) {
          try {
            await navigator.clipboard.writeText(licenseKey);
            setAlert(t("license.keyCopiedToClipboard"), "info");
          } catch (err) {
            console.error("Failed to copy license key:", err);
          }
        }
      } catch (e: any) {
        console.error(e);
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem, setAlert, t]
  );

  // SLAVE servers use SlaveServerForm (license key entry)
  // MASTER servers use ServerForm (full CRUD)
  if (!isMasterServer) {
    return <SlaveServerForm />;
  }

  return id && !item ? null : (
    <ServerForm onSubmit={onSubmit} editedItem={item} />
  );
}

export default Server;
